(function($) {
    'use strict';

    if ( typeof Awesomplete !== 'undefined' ){
        let companyNameInputFields = document.getElementsByName('company'),
            awesompleteInputs = [];

        if ( companyNameInputFields && companyNameInputFields.length > 0 ){
            for ( var i = 0, j = companyNameInputFields.length; i < j; i++ ){
                (function ( i ) {
                    awesompleteInputs[i] = new Awesomplete( companyNameInputFields[i], {
                        minChars: 2,
                        filter: Awesomplete.FILTER_STARTSWITH,
                        maxItems: ( screen && screen.width <= 768 ? 5 : 10 ),
                        list: []
                    });

                    companyNameInputFields[i].addEventListener( 'input', function( ev ) {
                        if ( this.value && this.value.length > 1 ){
                            let currAwesompleteInput = awesompleteInputs[i];

                            $.getJSON( `/wp-json/company-list/v1/companies?search=${ this.value }`, function( companies ) {
                                currAwesompleteInput.list = companies;
                                currAwesompleteInput.evaluate();
                            });
                        }
                    });
                }( i ));
            }
        }

        let billingCompanyNameInputFields = document.getElementsByName('billing-company'),
            awesompletebillingCompanyInputs = [];

        if ( billingCompanyNameInputFields && billingCompanyNameInputFields.length > 0 ){
            for ( var i = 0, j = billingCompanyNameInputFields.length; i < j; i++ ){
                (function ( i ) {
                    awesompletebillingCompanyInputs[i] = new Awesomplete( billingCompanyNameInputFields[i], {
                        minChars: 2,
                        filter: Awesomplete.FILTER_STARTSWITH,
                        maxItems: ( screen && screen.width <= 768 ? 5 : 10 ),
                        list: []
                    });

                    billingCompanyNameInputFields[i].addEventListener( 'input', function( ev ) {
                        if ( this.value && this.value.length > 1 ){
                            let currbillingCompanyAwesompleteInput = awesompletebillingCompanyInputs[i];

                            $.getJSON( `/wp-json/company-list/v1/companies?search=${ this.value }`, function( companies ) {
                                currbillingCompanyAwesompleteInput.list = companies;
                                currbillingCompanyAwesompleteInput.evaluate();
                            });
                        }
                    });
                }( i ));
            }
        }
    }
})(jQuery);

